export const isCordovaBuild = window.cordova;
